<template>
	<v-row>
		<v-col>
			<v-form
					v-model="formIsValid.checkout"
					ref="checkoutForm"
					class="mb-8"
			>

				<ui-box :form="$refs.checkoutForm" :eager="!!localPass.id" new-forms>

					<form-title title="Pre-Purchase Info"/>

					<form-divider inner/>

					<form-subsection title="Learn More">
						This description will be shown to a customer before they have ordered the
						pass. Include information about why they should get it!
					</form-subsection>

					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="localPass.short_description"
									:counter="2000"
									hide-details="auto"
									label="Learn More Description"
									outlined
									rows="4"
							></wysiwyg-input>
						</v-col>
					</v-row>
					<!-- End: Learn More Description -->

					<!-- Highlights -->
					<form-subsection title="Pass Highlights">

					</form-subsection>

					<v-row>
						<v-col>
							<wysiwyg-input
								v-model="localPass.highlights"
								auto-grow
									class="rounded-lg required"
									counter="750"

								label="Highlights"
									maxlength="750"
								outlined
								persistent-hint
								rows="4"
								:rules="rules.highlights"
							></wysiwyg-input>
						</v-col>
					</v-row>
					<!-- End: Highlights -->

					<!-- End: Advanced Checkout -->
				</ui-box>
			</v-form>

			<save-form
					:refs="$refs"
					:is-saving="isSaving"
					new-forms
					:save-text="saveText"
					@cancel-action="cancelChanges"
					@save-action="saveDestination"
			></save-form>


		</v-col>
	</v-row>
</template>

<script>

import customizationMixin from './Mixins/customizationMixin';

export default {
	name: 'CustomizeCheckin',
	mixins: [customizationMixin],
	data() {
		return {
			formIsValid: {
				checkout: false,
			},
		};
	},
	computed: {
		highlightPlaceholder() {
			return "Highlight 1\nHighlight 2\nHighlight 3";
		},
	},
};

</script>